import NavBar from "../components/navbar/navBar";
import Footer from "../components/footer";
import IntroSection from "../components/introSection";
import AchievementsSection from "../components/achivementsSection.jsx";
import Skills from '../components/skils.jsx';
import EducationSection from '../components/educationSection.jsx';
import Experience from '../components/experienceSection.jsx';
import Projects from '../components/projectsDone.jsx';
import Certification from '../components/certification.jsx';
import Contact from '../components/contact.jsx';

const HomePage = () => {
  return (
    <>
      <NavBar />
      <IntroSection />
      <AchievementsSection />
      <Skills />
      <EducationSection />
      <Experience />
      <Projects />
      <Certification />
      <Contact />
      <Footer />
    </>
  );
};

export default HomePage;
